import { Dispatch, SetStateAction } from 'react';
import Modal from '@/components/modal/Modal';
import { Col, Row } from '@/lib/utils';
import { BoldText, MediumText, RegularText } from '@/lib/Text';
import { colors } from '@/lib/colors';

type Props = {
    setIsVisible: Dispatch<SetStateAction<boolean>>;
    onClose: () => void;
    onDontSave: () => void;
    onSave: () => void;
};

const ModalNoSaveChangeVariable = ({ setIsVisible, onClose, onDontSave, onSave }: Props) => {
    return (
        <Modal
            setIsVisible={setIsVisible}
            whiteViewWidth={685}
            whiteViewHeight={301}
            borderRadius={25}
            onClose={onClose}
            isCloseButton
        >
            <div className="flex flex-col justify-center items-center p-[35px]">
                <Col className="flex w-full justify-start">
                    <MediumText fontSize={28} lineHeight={41} color={colors.Text_1}>
                        {`급여 내역 정보가 저장되지 않았어요.`}
                    </MediumText>
                    <MediumText fontSize={28} lineHeight={41} color={colors.Text_1}>
                        {`저장하고 나갈까요?`}
                    </MediumText>
                </Col>
                <Row className="absolute bottom-[35px] right-[35px] items-center">
                    <Col
                        className="bg-GREY w-[160px] h-[41px] justify-center items-center rounded-[9px] mr-[9px] cursor-pointer"
                        onClick={onDontSave}
                    >
                        <RegularText fontSize={16} lineHeight={20} letterSpacing={-0.32} color={colors.Text_1}>
                            저장 안 하고 나가기
                        </RegularText>
                    </Col>
                    <Col
                        className={`bg-primary w-[160px] h-[41px] justify-center items-center rounded-[9px] cursor-pointer  `}
                        onClick={onSave}
                    >
                        <RegularText fontSize={16} lineHeight={20} letterSpacing={-0.32} color={colors.white}>
                            저장 후 나가기
                        </RegularText>
                    </Col>
                </Row>
            </div>
        </Modal>
    );
};

export default ModalNoSaveChangeVariable;
